export const APP_STORE_URLS = {
  android: 'https://play.google.com/store/apps/details?id=com.aipsyhelp.app&pcampaignid=web_share',
  ios: 'https://apps.apple.com/app/id6748014564',
  web: 'https://chat.psyhelp.info'
};

/** Soft conversion values for Ads optimization (EUR). Tune in GTM if needed. */
export const APP_CTA_VALUES = {
  android: 5,
  ios: 5,
  web: 3
};

export const B2B_LEAD_VALUES = {
  corporate: 25,
  ngo: 25,
  contact: 10,
  webinar: 15
};
